"use client";

import AboutIncred from "./components/about-incred";
import TheTeam from "./components/team-incred";
import IncredGroup from "./components/our-vision";
import IncredInvestor from "./components/our-investors";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import { useAuth } from "@/context/authcontext";

export default function Home() {
    const { isAuthenticated } = useAuth();

    return (
        <>
            <div className="md:px-auto mx-auto max-w-[100%] bg-neutral-50 px-6 md:container md:bg-transparent">
                <Breadcrumb
                    paths={
                        [
                            { label: "Home", route: isAuthenticated ? "/platform" : "/" },
                            { label: "About" },
                        ] as BreadcrumbPath[]
                    }
                />
                <AboutIncred />
                <TheTeam />
            </div>
            <IncredInvestor />
            <div className="md:px-auto mx-auto max-w-[100%] bg-neutral-50 px-6 md:container md:bg-transparent">
                <IncredGroup />
            </div>
        </>
    );
}
